import { AuthAdapter as ClientAuthAdapter, configureAuthAdapter } from '@pba/client-auth';
import { type ReactNode, useEffect } from 'react';
import { getCurrentNodeToken, storeNodeToken } from 'common/services';
import { logout } from 'common/services/hooks';

const AuthAdapter = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    const adapter = new ClientAuthAdapter({
      getToken() {
        return getCurrentNodeToken();
      },
      onTokenUpdated(token) {
        storeNodeToken(token);
      },
      async onUnauthenticated() {
        await logout();
      },
    });
    configureAuthAdapter(adapter);
  }, []);

  return <>{children}</>;
};

export default AuthAdapter;
